// extracted by mini-css-extract-plugin
export default {"liveChatIcon":"ContactSupport_liveChatIcon__RjVKV"};